export default (value) => {
  const toNumber = Number(value);

  if (Number.isNaN(toNumber)) {
    return value;
  }

  return toNumber.toLocaleString();
};
